module.exports = __webpack_public_path__ + "img/Reading.de418b84.svg";